import * as THREE from "three";
import { Vector3 } from "three";
import { ViewManager } from "../CadEngine";
import { UBase } from "./UBase";

export class ULabel extends UBase {
  private m_dom: HTMLParagraphElement;

  constructor(view: ViewManager, root: HTMLDivElement) {
    super(view, root);
    this.m_dom = document.createElement("p");
    this.m_dom.style.width = "100%";
    this.m_dom.style.height = "100%";
    this.m_dom.style.fontSize = "10px";
    this.m_dom.style.textAlign = "right";
    this.m_dom.style.paddingTop = "2px";
    this.m_dom.style.border = "0px solid #101010";
    this.m_dom.style.background = "rgba(220,38,38,0)";
    this.m_dom.style.color = "#fff";
    this.m_panelDom.appendChild(this.m_dom);
    this.m_panelDom.style.pointerEvents = "none";
  }
  public SetVaule(
    label: string,
    location: Vector3 | undefined = undefined,
    orientation: Vector3 | undefined = undefined
  ): void {
    let text = this.m_dom.innerHTML;
    if (text != label) {
      this.m_dom.innerHTML = label;
      let width = label.length * 12 + 4;
      if (width <= 40) {
        width = 40;
      }
      this.m_panelDom.style.width = `${width}px`;
    }

    if (location && orientation) this.SetLocation(location, orientation);
  }
}
